import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Form, Button, Table } from 'react-bootstrap'
import Menu from '../Menu'
import Loginheader from '../Loginheader'
import Select from "react-select";
import DatePicker from "react-datepicker";
import * as Common from "../Common";
import parse from "html-react-parser";
import { useNavigate } from 'react-router-dom';

function InwardReport() {
    const sid = sessionStorage.getItem("sessionId");
    const [onceRun, setOnceRun] = useState(false);
    const navigate = useNavigate();

    const [srchStatus, setSrchStatus] = useState("ALL");
    const [ddReqStatusOptions, setDdReqStatusOptions] = useState([
        { "value": "ALL", "name": "ALL" },
        { "value": "CLS", "name": "Closed" },
        { "value": "OPN", "name": "Open" },
        { "value": "NEW", "name": "New" },
        { "value": "PRE", "name": "Pending Reprocess" },
        { "value": "REP", "name": "Reprocessed" },
        { "value": "PBC", "name": "Waiting for Branch Confirmation" },
        { "value": "PFC", "name": "Pending Fund Credit Confirmation" },
        { "value": "PBT", "name": "Pending Refund Approval By Accounts" },
        { "value": "PCR", "name": "Pending Refund Approval By Accounts Credit Received and Refund Requested" },
        { "value": "RAA", "name": "Refund Approved By Accounts" },
        { "value": "RFA", "name": "Refund Approved By ZM" },
        { "value": "REF", "name": "Refund Processed" },
        { "value": "NTT", "name": "New Outword TT" },
        { "value": "ACV", "name": "Add Cover Confirmed" },
        { "value": "ACA", "name": "Add Cover All" }
    ]);

    const [srchIssuer, setSrchIssuer] = useState(0);
    const [ddSrchIssuer, setDdSrchIssuer] = useState([]);
    const [srchToDate, setSrchToDate] = useState(new Date());
    const [srchFromDate, setSrchFromDate] = useState(new Date());

    const [srchBran, setSrchBran] = useState("0");
    const [ddSrchBranOptions, setDdSrchBranOptions] = useState([]);
    const [srchBranSelect, setSrchBranSelect] = useState([]);
    const [repOutput, setRepOutput] = useState("");
    const [repMode, setRepMode] = useState("D");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REPINWARD'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query == 1) {
                    Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                        setDdSrchIssuer(JSON.parse(result));
                    });
                    Common.callApi(Common.apiUser, [sid, 'branchallowedselect'], function (result) {
                        let resp = JSON.parse(result);
                        //setDdReqBranOptions(resp);
                        setDdSrchBranOptions(resp);
                    });
                } else {
                    navigate("/");
                }
            });
            setOnceRun(true);
        }
    }, [onceRun]);

    function handleSrchBranchOptions(v) {
        setSrchBranSelect(v);
        setSrchBran(v.value);
    }

    function genInwardReport() {
        var object1 = {
            right: "REPINWARD",
            mode: repMode,
            srchStatus: srchStatus,
            srchIssuer: srchIssuer,
            srchFromDate: Common.dateYMD(srchFromDate),
            srchToDate: Common.dateYMD(srchToDate),
            srchSrno: 0,
            srchBran: srchBran,
            ddReqStatusOptions: ddReqStatusOptions
        }
        if (repMode === "D") {
            Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(object1)]);
        } else if (repMode === "V") {
            Common.callApi(Common.apiReport, [sid, JSON.stringify(object1)], function (result) {
                setRepOutput(result);
            });
        }
    }

    return (
        <>
            <Loginheader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Inward Report</h2>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3}>
                        <Form.Group>
                            <Form.Label>Mode</Form.Label>
                            <Form.Select value={repMode} onChange={e => setRepMode(e.target.value)}>
                                {/* <option value="V">View</option> */}
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                            <Form.Label>Status {srchStatus}</Form.Label>
                            <Form.Select
                                value={srchStatus}
                                onChange={(e) => setSrchStatus(e.target.value)}>
                                {ddReqStatusOptions.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={3}>
                        <Form.Group >
                            <Form.Label>Issuer </Form.Label>
                            <Form.Select
                                value={srchIssuer}
                                onChange={(e) => setSrchIssuer(e.target.value)}>
                                {ddSrchIssuer.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>Branch</Form.Label>
                            <Select
                                value={srchBranSelect}
                                onChange={handleSrchBranchOptions}
                                options={ddSrchBranOptions}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>From Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={srchFromDate}
                                onChange={(date) => setSrchFromDate(date)}
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>To Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={srchToDate}
                                onChange={(date) => setSrchToDate(date)}
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-primary' size='sm' onClick={() => genInwardReport()}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>{parse(repOutput)}</Row>
            </Container >
        </>
    )
}

export default InwardReport
